module.exports = __webpack_public_path__ + "assets/images/familiar_disease_g.f4cd302b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/familiar_disease_g.png
// module id = 706
// module chunks = 1